// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationConsumerAppRationalPath = 'M83 89.5c0 5.799-4.701 10.5-10.5 10.5h-45C21.701 100 17 95.299 17 89.5v-79C17 4.701 21.701 0 27.5 0h45C78.299 0 83 4.701 83 10.5v79zM27.5 7a3.5 3.5 0 00-3.5 3.5v79a3.5 3.5 0 003.5 3.5h45a3.5 3.5 0 003.5-3.5v-79A3.5 3.5 0 0072.5 7H61l-4.6 6H43.6L39 7H27.5zM50 89a5 5 0 100-10 5 5 0 000 10zm2.62-59h6.843c0 6.598-2.571 12.736-7.153 17.298l9.666 13.18h-8.637L42.834 46.154l2.711-2.03C50.041 40.756 52.62 35.608 52.62 30zM41.998 60.478H35V30h6.998v30.478zm20.786-3.488a3.83 3.83 0 117.66 0 3.83 3.83 0 01-7.66 0z';
var IllustrationConsumerAppRational = baseIllustration('IllustrationConsumerAppRational', {
  getPath: () => IllustrationConsumerAppRationalPath
}, 'ColoredIllustrationConsumerAppRational');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationConsumerAppRational;
//# sourceMappingURL=index.js.map